import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';

import LearnerProfileDeleteResumeMutation from 'bundles/account-profile/components/recruiting-profile-viewer/queries/LearnerProfileDeleteResumeMutation.graphql';
import type {
  LearnerProfile_DeleteResumeMutation as DeleteResumeMutationData,
  LearnerProfile_DeleteResumeMutationVariables as DeleteResumeMutationVariables,
} from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/LearnerProfileDeleteResumeMutation';

export default function useDeleteResume() {
  const [deleteResumeMutation, mutationState] = useMutation<DeleteResumeMutationData, DeleteResumeMutationVariables>(
    LearnerProfileDeleteResumeMutation,
    { context: { clientName: 'gatewayGql' } }
  );

  const deleteResume = async (resumeUrl: string) => {
    try {
      const res = await deleteResumeMutation({
        variables: {
          input: {
            resumeUrl,
          },
        },
        context: {
          clientName: 'gatewayGql',
        },
      });

      const mutationResult = res.data?.LearnerProfile_DeleteResume;

      if (mutationState.error || res.errors?.length) {
        return false;
      }

      if (mutationResult?.__typename === 'LearnerProfile_DeleteResumeFailure') {
        return false;
      }

      return mutationResult?.__typename === 'LearnerProfile_DeleteResumeSuccess';
    } catch (e) {
      Sentry.captureException(e);
      return false;
    }
  };

  return {
    deleteResume,
  };
}
